import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu, Typography, Button, Space, Avatar, Dropdown } from 'antd';
import {
  DashboardOutlined,
  CarOutlined,
  DollarOutlined,
  TeamOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const { Header, Sider, Content } = AntLayout;
const { Title, Text } = Typography;

const StyledLayout = styled(AntLayout)`
  min-height: 100vh;
`;

const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 0 24px;
  border-bottom: 1px solid #f0f0f0;
`;

const Logo = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #1677ff;
`;

const StyledContent = styled(Content)`
  margin: 24px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  min-height: 280px;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const menuItems = [
  { key: '/', icon: <DashboardOutlined />, label: 'Dashboard' },
  { key: '/pending', icon: <CarOutlined />, label: "Kutayotgan e'lonlar" },
  { key: '/payments', icon: <DollarOutlined />, label: "To'lovlar" },
  { key: '/users', icon: <UserOutlined />, label: 'Foydalanuvchilar' },
  { key: '/admins', icon: <TeamOutlined />, label: 'Adminlar' },
  { key: '/settings', icon: <SettingOutlined />, label: 'Sozlamalar' },
];

export function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const dropdownItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Chiqish',
      onClick: handleLogout,
    },
  ];

  return (
    <StyledLayout>
      <Sider theme="light" width={250}>
        <div style={{ padding: '16px 24px' }}>
          <Logo>🚗 Moshina Bozor</Logo>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <AntLayout>
        <StyledHeader>
          <Title level={4} style={{ margin: 0 }}>Admin Panel</Title>
          <UserInfo>
            <Text type="secondary">
              {admin?.firstName || admin?.username || 'Admin'}
            </Text>
            <Dropdown menu={{ items: dropdownItems }} placement="bottomRight">
              <Avatar 
                style={{ backgroundColor: '#1677ff', cursor: 'pointer' }}
                icon={<UserOutlined />}
              />
            </Dropdown>
          </UserInfo>
        </StyledHeader>
        <StyledContent>
          <Outlet />
        </StyledContent>
      </AntLayout>
    </StyledLayout>
  );
}
